export class UserDetailsModel {
    userId?: number;
    userName: string;
    email: string;
    assignedModules?: Array<number>;
    constructor() {
    }
}
